<template>
  <multipane-impl :layout="layout"
      @paneResizeStart="handleResizeStart"
      @paneResize="handleResize"
      @paneResizeStop="handleResizeStop">
    <slot></slot>
  </multipane-impl>
</template>

<script>
import {Multipane} from "vue-multipane";
import {doLayoutElTable} from "@/utils/DomUtil";

export default {
  name: "Multipane",
  components: {
    MultipaneImpl: Multipane,
  },
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      multipaneResizeObserver: new ResizeObserver(this.cleanWidth),
      scheduledCleanWidth: null,
    };
  },
  mounted() {
    this.multipaneResizeObserver.observe(this.$el);
  },
  beforeDestroy() {
    this.multipaneResizeObserver.disconnect();
  },
  computed: {
    layout() {
      if(this.vertical) {
        return 'vertical';
      } else if(this.horizontal) {
        return 'horizontal';
      } else {
        return 'vertical';
      }
    }
  },
  methods: {
    handleResizeStart(pane, resizer, size) {
      this.$emit('paneResizeStart', pane, resizer, size);
      this.$emit('pane-resize-start', pane, resizer, size);
    },
    handleResize(pane, resizer, size) {
      this.cleanWidth();
      this.$emit('paneResize', pane, resizer, size);
      this.$emit('pane-resize', pane, resizer, size);
    },
    handleResizeStop(pane, resizer, size) {
      this.cleanWidth();
      this.$emit('paneResizeStop', pane, resizer, size);
      this.$emit('pane-resize-stop', pane, resizer, size);
    },
    cleanWidth() {
      if(this.scheduledCleanWidth) {
        return;
      }
      this.scheduledCleanWidth = setTimeout(_ => {
        this.scheduledCleanWidth = null;
        this.cleanWidthImmediately();
      }, 33);
    },
    cleanWidthImmediately() {
      doLayoutElTable(this.$el);
      this.$emit('pane-resizing');
    }
  },
}
</script>
